import clsx from 'clsx';
import { useEffect, useState, useCallback, CSSProperties } from 'react';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import RelatoriosService from "../../services/RelatoriosService";
import { IEsteira } from '../../interfaces/IEsteira';
import { IEsteira as IEmpresa } from '../../interfaces/IRelatorioCliente';
import { useAuth } from '../../contexts/AuthProvider';
import EmpresasService from '../../services/EmpresasService';
import ArquivoCardEsteiraService from '../../services/ArquivoCardEsteiraService';
import { IAprovacaoAlteracaoLancamento } from '../../interfaces/IAprovacaoAlteracaoLancamento';
import moment from 'moment';
import Swal from 'sweetalert2';
import { uniqueId } from 'lodash';

/*Tradução */
import './../../../i18n/config';
import { useTranslation } from 'react-i18next';

const styleScroll = {
    '::-webkit-scrollbar': {
        display: 'unset !important'
    }
} as CSSProperties;

const AprovacaoAlteracao = () => {
    const { usuario } = useAuth();
    const [mesesImportacao, setMesesImportacao] = useState<number[]>([]);
    const [empresas, setEmpresas] = useState<IEmpresa[]>([]);
    const [esteiras, setEsteiras] = useState<IEsteira[]>([]);
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [mesSelecionado, setMesSelecionado] = useState<number>(0);
    const [somenteAprovados, setSomenteAprovados] = useState<boolean>(false);
    const [esteiraSelecionada, setEsteiraSelecionada] = useState<number>(0);
    const [empresaSelecionada, setEmpresaSelecionada] = useState<number>(0);
    const [contasProcessando, setContasProcessando] = useState<number[]>([]);
    const [search, setSearch] = useState<string>('');
    const [contasSelecionadas, setContasSelecionadas] = useState<number[]>([]);
    const [aprovacoes, setAprovacoes] = useState<IAprovacaoAlteracaoLancamento[]>([]);

    const buscarAlteracoes = useCallback((esteira: number) => {
        setLoading(true);
        ArquivoCardEsteiraService.buscarAlteracoesPendentes(esteira).then((resp) => {
            setAprovacoes(resp);

            setTimeout(() => {
                setLoaded(true);
                setLoading(false);
            }, 2000);
        });
    }, []);

    const lancarContasProcessando = useCallback((values: number[]) => {
        setContasProcessando((old) => {
            const cp = [...old];
            return cp.concat(values);
        })
    }, []);

    const removerContasProcessando = useCallback((values: number[]) => {
        setContasProcessando((old) => {
            const cp = [...old];
            return cp.filter(f => !values.includes(f));
        })
    }, []);

    const onChangeCheckBox = useCallback((id: number, type: boolean) => {
        if (type) {
            setContasSelecionadas((old) => {
                const cp = [...old];
                if (!cp.find(f => f === id)) {
                    cp.push(id);
                }

                return cp;
            });
        } else {
            setContasSelecionadas((old) => {
                const cp = [...old];
                return cp.filter(f => f !== id);
            });
        }
    }, []);

    const onChangeCheckBoxAll = useCallback((type: boolean) => {
        if (type) {
            setContasSelecionadas(aprovacoes.map(i => i.id));
        } else {
            setContasSelecionadas([]);
        }
    }, [aprovacoes]);

    useEffect(() => {
        if (usuario) {
            RelatoriosService.obterEmpresasPorClienteID(usuario?.clienteID || 0, (x) => setEmpresas(x));
        }
    }, [usuario]);

    useEffect(() => {
        if (empresaSelecionada) {
            setEsteiraSelecionada(0);
            var emp = empresas.find(f => f.empresaID === empresaSelecionada)
            EmpresasService.obterEsteiras(emp?.empresaID || 0).then((resp) => {
                setEsteiras(resp);
            });
        }
    }, [empresaSelecionada]);

    useEffect(() => {
        if (esteiraSelecionada > 0 && !loading && !loaded) {
            buscarAlteracoes(esteiraSelecionada);
            const esteira = esteiras.find(f => f.id === esteiraSelecionada);
            const mesInicio = parseInt(esteira?.periodoInicio.toString().split('-')[1] || '0')
            const mesFim = parseInt(esteira?.periodoFim.toString().split('-')[1] || '0')
            setMesesImportacao(() => {
                let aux: number[] = [];

                for (let index = mesInicio; index <= mesFim; index++) {
                    aux.push(index);
                }

                return aux;
            });

        }
    }, [esteiraSelecionada, buscarAlteracoes, loading, esteiras, loaded]);

    const aceitar = useCallback(async (ids: number[]) => {
        try {
            lancarContasProcessando(ids);
            await ArquivoCardEsteiraService.aceitarAlteracao(ids);
            Swal.fire({
                text: 'A alteração foi aprovada com sucesso!',
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            setAprovacoes((old) => {
                const cp = [...old];
                const nw = cp.map((f) => {
                    if (ids.includes(f.id)) {
                        return {
                            ...f,
                            aprovado: true
                        }
                    }

                    return {
                        ...f
                    }
                });
                return nw;
            });
            removerContasProcessando(ids);
        } catch (e) {
            Swal.fire({
                text: 'Não foi possível realizar a aprovação, por favor valide suas permissões ou entre em contato com nosso suporte!',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });

            removerContasProcessando(ids);
        }

    }, []);

    const recusar = useCallback(async (ids: number[]) => {
        try {
            lancarContasProcessando(ids);
            await ArquivoCardEsteiraService.recusarAlteracao(ids);
            Swal.fire({
                text: 'A alteração foi recusada com sucesso!',
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            setAprovacoes((old) => {
                return old.filter(f => !ids.includes(f.id));
            });
            removerContasProcessando(ids);
        } catch (e) {
            Swal.fire({
                text: 'Não foi possível realizar a aprovação, por favor valide suas permissões ou entre em contato com nosso suporte!',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });

            removerContasProcessando(ids);
        }
    }, []);

    const { classes } = useLayout();

    return (<>
        <PageTitle breadcrumbs={[]}>{t('Aprovação de Alterações')}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
            </div>
        </div>
        <div className='row' style={styleScroll}>
            <div className='col-md-12'>
                <div className='row'>
                    <div className='col-md-3'>
                        <div className='form-group'>
                            <label>{t('Empresas:')}</label>
                            <select
                                defaultValue={0}
                                className='form-control'
                                value={empresaSelecionada}
                                onChange={(e) => setEmpresaSelecionada(parseInt(e.target.value))}
                            >
                                <option value={0}>{t('Selecione uma empresa')}</option>
                                {empresas.map((item) => (
                                    <option value={item.empresaID}>{`${item.razaoSocial}${item.cnpj && item.cnpj.replace(/[^A-Za-z0-9]/g, '').substring(8, 12) !== '0001' ? ` - ${item.cnpj}` : ''}`}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='col-md-3'>
                        <div className='form-group'>
                            <label>{t('Esteiras:')}</label>
                            <select
                                defaultValue={0}
                                value={esteiraSelecionada}
                                className='form-control'
                                onChange={(e) => {
                                    setEsteiraSelecionada(parseInt(e.target.value))
                                    setLoaded(false);
                                }}
                            >
                                <option value={0} defaultChecked={!esteiraSelecionada}>{t('Selecione uma esteira')}</option>
                                {esteiras.map((item) => (
                                    <option value={item.id}>{`${item.periodoInicioString} - ${item.periodoFimString}`}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='col-md-3 mt-8'>
                        <div className='row'>
                            <div className='col-md-2' style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" onChange={(e) => setSomenteAprovados(e.target.checked)} checked={somenteAprovados} />
                                    <label className="form-check-label">
                                        {t('Aprovados')}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {esteiraSelecionada > 0 && mesesImportacao.length > 0 && (
                    <div className='row mt-4'>
                        <div className='col-md-3'>
                            <div className='form-group'>
                                <label>{t('Mêses disponíveis')}:</label>
                                <select
                                    defaultValue={0}
                                    value={mesSelecionado}
                                    className='form-control'
                                    onChange={(e) => setMesSelecionado(parseInt(e.target.value))}
                                >
                                    <option value={0} defaultChecked={!esteiraSelecionada}>{t('Selecione um mês')}</option>
                                    {mesesImportacao.map((item) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        {mesSelecionado > 0 && (
                            <div className='col-md-3 mt-6'>
                                <button type='button' style={{ width: '100%' }} className='btn btn-danger' onClick={() => {
                                    const esteira = esteiras.find(f => f.id === esteiraSelecionada);
                                    const ano = parseInt(esteira?.periodoInicio.toString().split('-')[0] || '0')
                                    EmpresasService.processarRelatorioEstorno(esteiraSelecionada, mesSelecionado, ano);
                                }}>{t('Relatório de estorno')}</button>
                            </div>
                        )}

                        <div className='col-md-12'>
                            <div className='form-group'>
                                <label>{t('Busca')}:</label>
                                <input className='form-control' value={search} onChange={(e) => setSearch(e.target.value)} />
                            </div>
                        </div>
                    </div>
                )}
                <div className='row'>
                    {!loading && aprovacoes.length > 0 && contasProcessando.length <= 0 && (
                        <div className='col-md-12 mt-3'>
                            <div className='row'>
                                <div className='col-md-3'>
                                    <button type='button' style={{ width: '100%' }} className='btn btn-success' onClick={() => aceitar(contasSelecionadas)}>{t('Aceitar Selecionados')}</button>
                                </div>
                                <div className='col-md-3'>
                                    <button type='button' style={{ width: '100%' }} className='btn btn-danger' onClick={() => recusar(contasSelecionadas)}>{t('Recusar Selecionados')}</button>
                                </div>
                                <div className='col-md-12 mt-4'>
                                    <div className="col-md-12 mb-2">
                                        <div className='row'>
                                            <div className='col-md-2' style={{ display: 'flex', alignItems: 'center' }}>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" onChange={(e) => onChangeCheckBoxAll(e.target.checked)} checked={contasSelecionadas.length === aprovacoes.length} />
                                                    <label className="form-check-label">
                                                        {t('Selecionar todos')}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className='col-md-12'>
                        {loading && <div className="spinner-border text-success mt-4" role="status" style={{ marginBottom: '5px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <span className="sr-only">Loading...</span>
                        </div>}
                        {!aprovacoes || aprovacoes.length <= 0 && !loading && <p className='mt-5'>{t('Sem lançamentos encontrados')}</p>}
                        {!loading && aprovacoes.length > 0 && (
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th scope="col">{t('Origem')}</th>
                                        <th scope='col'>{t('Responsável')}</th>
                                        <th scope="col">{t('Data do Lançamento')}</th>
                                        <th scope="col">{t('Código Contábil')}</th>
                                        <th scope="col">{t('Descrição da Conta')}</th>
                                        <th scope="col">{t('Histórico')}</th>
                                        <th scope="col">{t('Valor')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        aprovacoes.filter((f) => {
                                            if (search) {
                                                const valueToFilter = `${f.conta} ${f.historico} ${f.lancamento.dataLancamento} ${f.lancamento.historico} ${f.lancamento.valorProvisaoRecolher} ${f.valor}`
                                                if (valueToFilter.toLowerCase().includes(search.toLowerCase())) {
                                                    return f;
                                                }

                                                return null;
                                            }

                                            return f;
                                        }).filter((i) => i.aprovado == somenteAprovados).map((item) => (
                                            <>
                                                {contasProcessando.includes(item.id) ? (
                                                    <tr key={uniqueId()}>
                                                        <th>
                                                            <div className="spinner-border text-success" role="status" style={{ marginBottom: '5px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                                                <span className="sr-only">Loading...</span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            {t('Estamos processando esse lançamento, por favor aguarde...')}
                                                        </th>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        <tr style={{ color: 'red' }} key={uniqueId()}>
                                                            <th style={{ paddingTop: '20px' }}>
                                                                <div className="form-check" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <input className="form-check-input" type="checkbox" checked={contasSelecionadas.includes(item.id)} onChange={(e) => onChangeCheckBox(item.id, e.target.checked)} />
                                                                </div>
                                                            </th>
                                                            {!item.aprovado ? <th><button onClick={() => aceitar([item.id])} type='button' className='btn btn-success' style={{ width: '100%' }}>{t('APROVAR')}</button></th> : <th></th>}
                                                            {!item.aprovado ? <th><button onClick={() => recusar([item.id])} type='button' className='btn btn-danger' style={{ width: '100%' }}>{t('RECUSAR')}</button></th> : <th></th>}
                                                            {item.tipo !== "Estorno" ? <th>{t('De')}:</th> : <th></th>}
                                                            <th>{item.responsavel.nome}</th>
                                                            <th>{moment(item.lancamento.dataLancamento).format('DD/MM/YYYY')}</th>
                                                            <th style={{ fontWeight: item.conta ? 'bold' : 'unset' }}>{item.lancamento.codigoContabil}</th>
                                                            <th style={{ fontWeight: item.conta ? 'bold' : 'unset' }}>{item.lancamento.descricaoCodigoContabil}</th>
                                                            <th style={{ fontWeight: item.historico ? 'bold' : 'unset' }}>{item.lancamento.historico}</th>
                                                            <th style={{ fontWeight: item.valor ? 'bold' : 'unset' }}>{item.lancamento.valorProvisaoRecolher.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</th>
                                                            {item.tipo === 'Estorno' && <th style={{ fontWeight: 'bold' }}>{item.tipo}</th>}
                                                        </tr>
                                                        {item.tipo !== 'Estorno' && (
                                                            <tr style={{ color: 'green', border: 'none' }}>
                                                                <th></th>
                                                                <th></th>
                                                                <th></th>
                                                                <th>{t('Para')}:</th>
                                                                <th>{t('Sem responsável')}</th>
                                                                <th>{moment(item.lancamento.dataLancamento).format('DD/MM/YYYY')}</th>
                                                                <th style={{ fontWeight: item.conta ? 'bold' : 'unset' }}>{item.conta || item.lancamento.codigoContabil}</th>
                                                                <th style={{ fontWeight: item.conta ? 'bold' : 'unset' }}>{item.descricaoCodigoContabil}</th>
                                                                <th style={{ fontWeight: item.historico ? 'bold' : 'unset' }}>{item.historico || item.lancamento.historico}</th>
                                                                <th style={{ fontWeight: item.valor ? 'bold' : 'unset' }}>{item.valor ? item.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : item.lancamento.valorProvisaoRecolher.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</th>
                                                            </tr>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        ))
                                    }
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default AprovacaoAlteracao;